import React from 'react'
import popupStyles from "./popup.module.scss";

const popup = (props) => (
    props.show ?
        <div className={popupStyles.popup}>
            <div onClick={props.onClosePopup} className={popupStyles.popupCloseBtn}/>
            {props.children}
        </div>
        : null
);

export default popup;
